// Shared presentational cells for a ticker's TickerSignals bundle (types/Signals.d.ts) —
// extracted from Watchlist.tsx so TopStocks.tsx can render the same compact badges without
// duplicating them.

const prettyPattern = (t: string) => t.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export function SignalCell({s}: {s?: TickerSignals}) {
  const f = s?.featured;
  if (!f) return <span className="text-muted">—</span>;
  const up = f.direction === "up";
  return (
    <span style={{color: up ? "#059669" : "#DC2626", fontWeight: 600, fontSize: 13}}>
      {up ? "▲ Bullish" : "▼ Bearish"} · {f.window}d ({(up ? f.fraction_up : f.fraction_dn).toFixed(1)}%)
    </span>
  );
}

export function PatternCell({s}: {s?: TickerSignals}) {
  const p = s?.pattern;
  if (!p) return <span className="text-muted">—</span>;
  return (
    <span style={{fontSize: 13}}>
      {prettyPattern(p.pattern_type)}
      <span className="text-muted"> · {Math.round(p.confidence * 100)}%</span>
      {p.sentiment && (
        <span style={{color: p.sentiment === "bullish" ? "#059669" : "#DC2626"}}> · {p.sentiment}</span>
      )}
    </span>
  );
}

export function MomentumCell({s}: {s?: TickerSignals}) {
  const m = s?.momentum_rank;
  if (!m || m.upr_rank === undefined) return <span className="text-muted">—</span>;
  const chg = m.upr_rank_chg ?? 0;
  return (
    <span style={{fontSize: 13}}>
      {Math.round(m.upr_rank)}
      <span style={{color: chg > 0 ? "#059669" : chg < 0 ? "#DC2626" : "var(--text-muted)"}}>
        {" "}{chg > 0 ? `+${Math.round(chg)}` : chg < 0 ? Math.round(chg) : ""}
      </span>
    </span>
  );
}
